import { Col, Card, Tabs } from 'antd'
import { fadeInRight } from 'react-animations'
import styled, { keyframes } from 'styled-components'

import Education from './education'
import Experience from './experience'
import Home from './home'
import Interests from './interests'
import Portfolio from './portfolio'
import Publications from './publications'
import Skills from './skills'

const fadeInRightAnimation = keyframes`${fadeInRight}`
const FadeInRightCard = styled(Card)`
  animation: 1s ${fadeInRightAnimation}
`

export default function Pages() {

  return <Col xs={{ span: 24 }} md={{ span: 16 }} lg={{ span: 16 }} xxl={{ span: 18 }}>
    <FadeInRightCard style={{ backgroundColor: '#fff' }} bordered={false}>
      <Tabs animated={{ inkBar: true, tabPane: true }} defaultActiveKey='home' items={[
        <Home name='profile summary' />,
        <Education name='education' />,
        <Experience name='work experience' />,
        <Publications name='publications' />,
        <Skills name='skills' />,
        <Portfolio name='portfolio' />,
        <Interests name='Other interests' />
      ].map((item, _) => {
        return {
          label: item.props.name,
          key: item.type.name.toLowerCase(),
          children: item,
        }
      })} />
    </FadeInRightCard>
  </Col>
}